import { css } from '@bts-web/utils-style-engine';

export const SkeletonElement = ({
  className = '',
  width = '100%',
  height = '40px',
  borderRadius = '0px',
  testId,
  maxWidth,
  minWidth,
  backgroundColor = 'neutrals.fill_focused',
  ...rest
}: {
  className?: string;
  width?: string;
  maxWidth?: string;
  minWidth?: string;
  height?: string;
  borderRadius?: string;
  testId?: string;
  backgroundColor?: string;
  [key: string]: any;
}) => (
  <div
    className={`${css({
      width: width,
      height: height,
      borderRadius: borderRadius,
      maxWidth,
      minWidth,
      // ! Below gradient is useful for making this element be treated as content by performance measuring tools
      // ? The issue: Chromium's paint-timing detector only counts text, images, or elements with a background-image as "contentful" for FCP.
      // ? A plain CSS background-color (which is what background: backgroundColor resolves to here) is explicitly excluded — it's too common a false-positive signal for "real content."
      backgroundLinear: 'to-r',
      gradientFrom: backgroundColor,
      gradientTo: backgroundColor,
    })} ${className ?? ''}`}
    data-testid={testId || 'skeleton-element'}
    {...rest}
  ></div>
);
